import getTranslation from '@/i18n/getTranslation'

export const statusType = [
  {
    value: '',
    label: getTranslation('全部')
  },
  {
    value: 1,
    label: getTranslation('生效')
  },
  {
    value: 2,
    label: getTranslation('失效')
  }
]
